import ROUTE_NAMES from '@/app/admin/router/router-const'
export default [
  {
    path: 'slots',
    name: ROUTE_NAMES.SLOTS,
    component: () => import('../SlotsPage.vue'),
  }
]